export default __webpack_public_path__ + "static/media/how-3b.ea087782.png";